import request from '@/utils/request'

// 登录方法
export function login(username, password) {
  const data = {
    account: username,
    passwd: password,
    loginType:'1'
  }
  return request({
    url: '/center/portal/login',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/api/user/get_center_info',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
/*
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}*/

// 获得浏览器版本号
export function getVersion() {
  return request({
    url: '/browser/pro/get',
    method: 'get'
  })
}

// 获取当前XP最新版本信息
export function getXpVersion() {
  return request({
    url: '/browser/pro/get_XP',
    method: 'get'
  })
}


// 获取上下线状态
export function getOnlineStatusFlag(params) {
  return request({
    url: '/api/internetHospital/doctor/getOnlineFlag',
    method: 'get',
    params: params
  })
}

// 改变上下线状态
export function updateOnlineFlag(params) {
  return request({
    url: '/api/internetHospital/doctor/updateOnlineFlag',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js